import * as React from 'react';
import { Route } from 'react-router-dom';
import DesignProject from './containers/designProject/designProject';
import DesignProjects from './containers/designProjects/designProjects';
import Home from './containers/home/home';
import InternalNews from './containers/internalnews/internalnews';
import Invoice from './containers/invoice/invoice';
import Invoices from './containers/invoices/invoices';
import Layout from './containers/layout/layout';
import News from './containers/news/news';
import Opportunitie from './containers/opportunitie/opportunitie';
import Opportunities from './containers/Opportunities/opportunities';
import Order from './containers/order/order';
import Orders from './containers/orders/orders';
import Search from './containers/search/search';
import Shipment from './containers/shipment/shipment';
import Shipments from './containers/shipments/shipments';
import Dragons from './containers/test/hereBeDragons';

export const routes = (
    <Layout>
        <Route exact={true} path="/" component={Home} />
        <Route path="/qto" component={Dragons} />
        <Route path="/opportunities" component={Opportunities} />
        <Route path="/ductdesign" component={DesignProjects} />
        <Route path="/ductdesignproject/:id" component={DesignProject} />
        <Route path="/orders" component={Orders} />
        <Route path="/invoices" component={Invoices} />
        <Route path="/order/:id" component={Order} />
        <Route path="/invoice/:id" component={Invoice} />
        <Route path="/opportunitie/:id" component={Opportunitie} />
        <Route path="/internalnews" component={InternalNews} />
        <Route path="/news" component={News} />
        <Route path="/resources" component={Dragons} />
        <Route path="/shipments" component={Shipments} />
        <Route path="/shipment/:id" component={Shipment} />
        <Route path="/search" component={Search} />
    </Layout>
);

export default routes;



// WEBPACK FOOTER //
// ./src/routes.tsx